import { env } from "~/env";

export const Footer = () => {
  return (
    <footer>
      <div className="flex flex-col items-end gap-y-2 pt-6 text-sm md:pt-4">
        <div className="text-midnight-indigo/80">
          <a
            className="cursor-pointer underline"
            href={`mailto:${env.VITE_ELEKTRA_CARE_EMAIL}`}
          >
            {env.VITE_ELEKTRA_CARE_EMAIL}
          </a>{" "}
          |{" "}
          <a
            href={`tel:${env.VITE_SUPPORT_PHONE_NUMBER}`}
            className="cursor-pointer"
          >
            {env.VITE_SUPPORT_PHONE_NUMBER}
          </a>
        </div>
        <span className="text-footer-text">
          © {new Date().getFullYear()}, Elektra Health
        </span>
      </div>
    </footer>
  );
};
